export const apiRoot = '/api/v1';
//const public_client_id = 'admin_public';
//const public_client_secret = 'czZCaGRSa3F0MzpnWDFmQmF0M2JW';
export const defaultHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
};
